module.exports = "/images/vendor/flag-icon-css/flags/1x1/ht.svg?34eb5f592af7e3948f4dd6a7593902e8";